import { Menu, Popover, Row, Col, MenuProps } from 'antd';
import { useContext, useEffect, useState } from 'react';
import MobileContext from './common/MobileContext';
import config from './common/config';
import { UnorderedListOutlined } from '@ant-design/icons';

import 'antd/dist/antd.less';

import './styles/Header.less';

function Header() {
  const [current, setCurrent] = useState('');
  const [menuVisible, setMenuVisible] = useState(false);
  const [headerClass, setHeaderClass] = useState('');
  const globalCtx: any = useContext(MobileContext);
  const items: MenuProps['items'] = [
    {
      label: (
        <a href="/docs/react/introduce" rel="noopener noreferrer">
          PC
        </a>
      ),
      key: 'pc',
    },
    {
      label: (
        <a href="/downloads" rel="noopener noreferrer">
          Downloads
        </a>
      ),
      key: 'design',
    },
  ];

  useEffect(()=> {
    setHeaderClass(globalCtx.state.backTop && globalCtx.state.nextSlide === 0 ? 'ani-header' : '');
  }, [globalCtx.state])

  const menu = (
    <Menu
      onClick={(e: any) => {
        setCurrent(e.key);
      }}
      selectedKeys={[current]}
      items={items}
    />
  );
  return (
    <header id="header" className={headerClass}>
      <Row className="header-inner">
        <Col span={12} className="col-logo">
          <a href="/docs/react/introduce" className="logo">
            <img
              src={config.getFullUrl('/aurum-large.svg')}
              className="aurum-logo"
              alt="aurum logo"
            />
          </a>
        </Col>
        <Col span={12} className="col-menu">
          <Popover
            overlayClassName="popover-menu"
            placement="bottomRight"
            content={menu}
            trigger="click"
            visible={menuVisible}
            className="sub-items"
            arrowPointAtCenter
            onVisibleChange={(visible: boolean) => setMenuVisible(visible)}
          >
            <UnorderedListOutlined
              className="nav-phone-icon"
              onClick={() => setMenuVisible(true)}
            />
          </Popover>
        </Col>
      </Row>
    </header>
  );
}

export default Header;
